import { useEffect } from "react";
import { shallowEqual } from "react-redux";
import { useCarConfigDispatch, useCarConfigSelector } from "../redux/store";
import { getInsuranceQuoteIdFromStorage, getSessionStorageParams } from "../utils/sessionStorage";
import { showAemInsuranceRates } from "../../../../common-deprecated/settings/utils/financeSettingUtilsAem";
import { AemFmComponent } from "../../../../common-deprecated/utils/aemFlexibilityMatrixUtils";
import { updateInsuranceQuote } from "../redux/slices/CarConfigFinanceSlice";
import { startInsuranceRateFetch } from "../redux/slices/CarConfigInsuranceSlice";

const useAphInsuranceInit = (): void => {
    const dispatch = useCarConfigDispatch();
    const commonSettings = useCarConfigSelector((state) => state.commonSettings);
    const sessionStorageParams = useCarConfigSelector(getSessionStorageParams, shallowEqual);
    const insuranceQuoteId = useCarConfigSelector((state) => state.finance.quotes.insurance);
    const modelCode = useCarConfigSelector((state) => state.car.model.internalCode);
    const modelId = useCarConfigSelector((state) => state.car.model.id);

    const insuranceEnabled = showAemInsuranceRates(commonSettings, AemFmComponent.Carconfig, "new", modelCode);

    useEffect(() => {
        if (!insuranceEnabled) return;

        if (!insuranceQuoteId) {
            const insuranceSessionsQuote = getInsuranceQuoteIdFromStorage(sessionStorageParams, modelId);

            if (insuranceSessionsQuote)
                dispatch(updateInsuranceQuote({ insurance: insuranceSessionsQuote, hideNotification: true }));
            else dispatch(startInsuranceRateFetch());
        }

        // Should only run once
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
};

export default useAphInsuranceInit;
